import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useForm, useFieldArray } from 'react-hook-form'
import { gql, useMutation, useQuery } from "@apollo/client";
import { CREATE_API_CONFIG, GET_API_CONFIG_BY_ID, GET_TENANT_BY_ID } from "../../graphql/TenantQueries";
import { Typography } from "@mui/material";
import ErrorDisplay from "../common/ErrorDisplay";


function AddApiConfigModal({ fieldData, setOpenAddApiModal, setOpenActionModal }: any) {
    const { register, handleSubmit, formState: { errors }, control, watch } = useForm({
    })
    const [addTenantApiConfig, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_API_CONFIG, {
        refetchQueries: [
          {query: GET_API_CONFIG_BY_ID, variables: { id: fieldData }  }, 
          'getApiConfigByTenantId' 
        ],
      });
    const { loading, error, data } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })
    const submit = async (formData: any) => {
        try {
            await addTenantApiConfig({ variables: { input: { ...formData, tenant: {name: `${data.getTenantById.name}`, id: `${data.getTenantById.id}`, displayName: `${data.getTenantById.displayName}` }} } });
            setOpenActionModal(false);
            setOpenAddApiModal(false);
        } catch (error) {
            console.error('Error adding API config:', error);
        }
    }

    if(loading) return <Typography>Loading...</Typography>

    return (
            <div className={styles["formModalContainer"]}>
                <div className={styles["title"]}>
                    <h1>Add API Config</h1>
                </div>
                <hr></hr>
                <div className={styles["body"]}>
                    <form onSubmit={handleSubmit(submit)}>
                        <div style={{display: 'block'}}>
                        <label className={styles["label"]}>API Configuration Name</label>
                        <input {...register('name')} className={styles["input"]}></input>
                        <label className={styles["label"]}>API Key</label>
                        <input {...register('key')} className={styles["input"]}></input>
                        <label className={styles["label"]}>API URL</label>
                        <input {...register('url')} className={styles["input"]} ></input>
                        </div>
                        <div style={{display: 'block'}}>
                        <label className={styles["label"]}>Collector Type</label>
                        <input {...register('collectorType')} className={styles["input"]} ></input>
                        <label className={styles["label"]}>Timezone</label>
                        <input {...register('timezone')} className={styles["input"]} ></input>
                        <label className={styles["label"]}>Enabled</label>
                        <input {...register('enabled')} className={styles["input"]} type='checkbox' ></input>
                        </div>


                        <div style={{ display: 'flex', alignContent: 'center' }}>
                            <button
                                onClick={() => {
                                    setOpenAddApiModal(false);
                                }}
                                className={styles["button"]}
                            >
                                Cancel
                            </button>
                            <input type='submit' className={styles["button"]} />
                        </div>
                    </form>
                </div>
                <ErrorDisplay error={mutationError} />
                <div className={styles["footer"]}>
                </div>
            </div>
    )
}

export default AddApiConfigModal;